module.exports = __webpack_public_path__ + "img/product-img-nine.717ab1de.png";